import { X } from "react-feather";

const ImportModal = ({
  isOpen,
  onClose,
  onImport,
  onDownloadSample,
  modalTitle = "Import Items",
  importTitle = "📤 Import Excel File",
  importDescription = "Upload an Excel file",
  downloadTitle = "📥 Download Sample Template",
  downloadDescription = "Get a pre-formatted Excel template with examples",
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1050,
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
          maxWidth: "90%",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <div
          className="modal-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #dee2e6",
            paddingBottom: "15px",
            marginBottom: "15px",
          }}
        >
          <h5 className="modal-title" style={{ margin: 0, fontWeight: "600" }}>
            {modalTitle}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "1.5rem",
              cursor: "pointer",
              padding: 0,
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          <p style={{ marginBottom: "20px", textAlign: "center" }}>
            Choose an option to continue:
          </p>
          <div className="d-flex flex-column gap-2">
            <div
              className="import-option p-3 border rounded"
              style={{ cursor: "pointer" }}
              onClick={onImport}
            >
              <h6 style={{ margin: "0 0 5px 0" }}>{importTitle}</h6>
              <p style={{ margin: 0, fontSize: "0.9rem", color: "#6c757d" }}>
                {importDescription}
              </p>
            </div>
            <div
              className="import-option p-3 border rounded"
              style={{ cursor: "pointer" }}
              onClick={onDownloadSample}
            >
              <h6 style={{ margin: "0 0 5px 0" }}>{downloadTitle}</h6>
              <p style={{ margin: 0, fontSize: "0.9rem", color: "#6c757d" }}>
                {downloadDescription}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ImportModal;
